<template>
    <div>

            <v-toolbar color="white"
          flat class="fixed-bar">
          <fieldset class="inline-form input-38">
              <v-text-field
                           v-model="filter"
                           append-icon="mdi-filter"
                           label="Type to filter"
                           
                         ></v-text-field>
              <v-select
                                v-model="selectedRig"
                                :items="rigsDropBox"
                                :menu-props="{ maxHeight: '400' }"
                                label="Select Rig"
                                item-text="rig"
                                item-value="id"
                              ></v-select>
            <v-btn @click="dialog = true" color="primary" dark>Add Component</v-btn>
          </fieldset>
            </v-toolbar>

                <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
                    <v-card color="lighten-1">
                        <v-toolbar>
                                <v-toolbar-title>
                                    <span class="headline">{{formTitle}}</span>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-form ref="form" v-model="valid" class="row">
                                        <v-col cols="12" md="12">
                                      
                                            <v-select v-model="editedItem.component_type_id"
                                            :items="componentTypes"
                                              item-text="name"
                                            item-value="id"
                                            label="Type"
                                            >
                                            </v-select>
                                        
                                        <fieldset class="inline-form">
                                                <v-text-field label="Number" v-model="editedItem.name"></v-text-field>

                                                <v-text-field label="SN" v-model="editedItem.SN"></v-text-field>

                                            </fieldset>

                                        <fieldset class="inline-form input-3">

                                                
                                            <v-text-field class="date-time-field" type="date" :rules="req"
                                                 v-model="editedItem.madeDate"
                                                 label="Date of Manufacture" 
                                               ></v-text-field>

                                            <v-text-field label="jumps Number Check" v-model="editedItem.jumpNumCheck" required type="number"
                                            ></v-text-field>


                                        </fieldset>

                                         <fieldset class="inline-form" v-if="editedIndex == -1">
                                                

                                            <v-text-field label="Qty" v-model.number="editedItem.qty" type="number"
                                            ></v-text-field>

                                               <v-text-field class="date-time-field" type="date"
                                                 v-model="editedItem.lastInspectionDate"
                                                 label="Last Check" 
                                               ></v-text-field>

                                            </fieldset>



                                <fieldset class="inline-form">
                                    <v-text-field label="Number of" v-model="editedItem.interval" required type="number" :rules="req"
                                                ></v-text-field>
                                    
                                    <v-select v-model="editedItem.intervalType" :rules="req"
                                                :items="['days','months','years']"
                                                item-text="Interval"
                                                item-value="intervalType"
                                                :value="editedItem.intervalType"
                                                label="Interval"
                                                >
                                                </v-select>
                                </fieldset>

                                        <v-text-field label="Description" v-model="editedItem.description"></v-text-field>                                            
                                </v-col>
                                        

                                    </v-form>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            

        <v-data-table
            :search="filter"
            :headers="headers"
            :items="componentsByRig"
            :items-per-page="25"
            :expanded.sync="allExpandedComps"
            :item-class="row_classes" 
            show-expand
            class="elevation-1">

               <!--  <template v-slot:item.type="{ item }">
                    {{item.component_type.name}} - {{item.name}} <br /> <small>SN:</small> {{ item.SN }} 
                </template> -->
                
                <template v-slot:item.lastInspectionDate="{ item }">
                    <span v-if="item.lastInspectionDate">{{new Date(item.lastInspectionDate).toLocaleString("en-AU",  { timeZone : "UTC", year: 'numeric', month: 'short', day: 'numeric' })}}</span>
                    
                </template>

                <template v-slot:item.nextInspectionDate="{ item }">
                    <span v-if="item.nextInspectionDate">{{new Date(item.nextInspectionDate).toLocaleString("en-AU",  { timeZone : "UTC", year: 'numeric', month: 'short', day: 'numeric' })}}</span>
                    
                </template>

                <template v-slot:expanded-item="{ headers, item }">

                        <td :colspan="headers.length" class="expanded-actions">

                            <v-switch :success="item.status == 1 ? true : false" @change="updateStatus(item)"
                                  v-model="item.status"
                                  inset
                                  :label="getSwitchLabel(item.status)"
                            ></v-switch>
                            
                            <v-btn icon small class="blue--text" @click="reset(item)">
                                <v-icon center>mdi-update</v-icon>
                                                </v-btn>
                            
                            <v-btn icon small @click="edit(item)">
                                <v-icon center>mdi-pencil</v-icon> 
                                                </v-btn>
                            
                            <v-btn :disabled="item.status == 1" icon small color="red" @click="deleteComponent(item.id)">
                                <v-icon center>mdi-delete-forever</v-icon> 
                                                </v-btn>
                        </td>
                </template>


                <template v-slot:item.jumpNumCheck="{item}">
                <span class="jumpsCount"><b>{{item.jumps || 0 }}</b>/<small>{{item.jumpNumCheck}}</small></span>
                <span v-if="item.jumpsLeft" class="jumpsCount">{{item.jumpsLeft}} left</span>
            </template>

        </v-data-table>
    </div>
</template>

<style>
.v-data-table>.v-data-table__wrapper>table>tbody>tr>td:last-child { height: auto }
</style>

<script>
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
                headers: [
                //{ text: 'ID', align: 'start', sortable: true, value: 'id', }, 
                    // { text: ' ', align: 'start', sortable: true, value: 'type', }, 
                    { text: 'Type', align: 'start', sortable: true, value: 'component_type.name', }, 
                    { text: 'Jumps', align: 'start', sortable: true, value: 'jumpNumCheck', }, 

                    { text: 'Number', align: 'start', sortable: true, value: 'name', },
                    { text: 'SN', align: 'start', sortable: true, value: 'SN', },
                    
                    // { text: 'Jumps Left', align: 'start', sortable: true, value: 'jumpsLeft' }, 
                    { text: 'Next Inspection', align: 'start', sortable: true, value: 'nextInspectionDate', }, 
                     { text: 'Last Check', align: 'start', sortable: true, value: 'lastInspectionDate', },
                     { text: 'Check Notes', align: 'start', sortable: true, value: 'lastCheckNotes', },
                    
                     
                    { text: 'Description', align: 'start', sortable: true, value: 'description', },
                    // { text: '', align: 'start', sortable: true, value: 'status' }                
                ],
                filter: "",
                dialog: false,
                editedIndex: -1,
                valid: true,
                lazy: true,
                isEditing: null,
                selectedRig : null,

                editedItem: {
                    name: "",
                    qty: 1,
                    
                    component_type_id : null,

                    SN : "", 
                    madeDate : null, 
                    jumpNumCheck : 0,
                    interval : 0,
                    intervalType : "", 
                    description : " -- ",
                    lastCheckNotes : "",
                    lastInspectionDate : null,
                    client_id : this.$store.state.uuid
                },



                req: [ v => !!(v && v.length) || 'Item is required'],

                
            }
        },

        mounted () {
            this.$store.dispatch('fetchComponents')
           
        },


        computed: {
            ...mapState(['components','componentTypes','rigs']),


            rigsDropBox() {
                
                const allItems = [{id: null, 
                                  rig: "Available Components (no Rig)", 
                                  
                                }]

                 return allItems.concat(this.rigs)
            },

            componentsByRig() {

                if( !this.selectedRig ) {

                return this.components.filter(function(c) {

                    return c.rig_id == 0
                  })

                } else {

                    const selectedRig = this.selectedRig
                
                    return this.components.filter(function(c) {

                        const ID = c.rig ? c.rig.id : 0
                        return ID == selectedRig
                      })
                }

            },


            allExpandedComps : {


                get()  {
                    return this.components || []
                },


                set() {
                    return []
                }



            },


            formTitle () {
                return this.editedIndex === -1 ? 'New Component' : 'Edit Component'
            },
        },

        watch: {

            dialog (val) {
                val || this.close()
            },

        },
        
        methods: {

            row_classes(item) {


                
            let InspDate = new Date(item.nextInspectionDate +'T23:59:00')

                if ( InspDate.isWithinWeek() || (item.jumpsLeft && item.jumpsLeft <= 5 && item.jumpsLeft > 0) ) {


                     return 'amber'

                } else if ( InspDate.isPast() || item.jumpsLeft <= 0 ) {



                  return 'red lighten-1'

                } else {

                    return ""
                }

           
            },

            showSnack(item) {
                  this.$emit('showSnack', item)

                },

            updateStatus(item) {

                this.editedIndex = this.components.indexOf(item)
                this.editedItem = Object.assign({}, item)


                const rid_id = c.rig ? item.rig.id : 0,

                offline = this.components.filter(function(c) {

                        const rig_ID = c.rig ? c.rig.id : 0
                        return rig_ID == rid_id && c.status == 0

                      })


                this.editedItem.updateRig = true

                if ( offline.length > 0 && item.status ) {

                     //this.$emit('showSnack')

                     this.editedItem.updateRig = false

                } 

                axios.put('/api/components/updateStatus/' + this.editedItem.id, this.editedItem)
                        .then( response => {
                            

                            const selectedRig = this.selectedRig,
                            newStatus = this.editedItem.status

                            if (this.editedItem.updateRig )

                               {
                                this.rigs.forEach( function(r) {
                               
                                    r.status = r.id == selectedRig ? newStatus : r.status
                               
                                })
                               }

                            this.close()
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })
                    



            },

            getSwitchLabel(val) {

                return val ? 'Online' : 'Offline'
            },

            edit(item) { 

                this.editedIndex = this.components.indexOf(item)
                this.editedItem = Object.assign({}, item)

                this.dialog = true
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  
                })
              },


              save () {

                this.editedItem.client_id = this.$store.state.uuid
                this.editedItem.description = this.editedItem.description ? this.editedItem.description : " -- "

                if (this.editedIndex > -1) { 


                    axios.put('/api/components/' + this.editedItem.id, this.editedItem)
                        .then( response => {

                                Object.assign(this.components[this.editedIndex], this.editedItem)
                            
                            this.close()
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

                  
                } else {

                    this.editedItem.name = this.editedItem.name ? this.editedItem.name : " "


                    axios.post('/api/components', this.editedItem)
                    .then( response => {

                        
                                this.$store.dispatch('fetchComponents') 
                        

                        this.close()
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              },

              deleteComponent(id) {
                confirm('Are you sure you want to delete this Component? This action can not be undone') && 

                axios.delete('/api/components/' + id)
                        .then( response => {

                            const index = this.components.map(function (f) { return f.id }).indexOf(id)

                            this.$store.state.components.splice(index, 1)
                        })
                        .catch( err => {
                            console.log( err )
                        })
              },

              reset(item) {


                var checkNotes = prompt('Inspection Notes', '--') 

                  if ( checkNotes ) {
                        
                        this.editedIndex = this.components.indexOf(item)
                        this.editedItem = Object.assign({}, item)

                        this.editedItem.lastCheckNotes = checkNotes


                        axios.put('/api/components/reset/' + this.editedItem.id, this.editedItem).then( response => {
                        

                        this.editedItem.nextInspectionDate = response.data.nextInspectionDate
                        this.editedItem.lastInspectionDate = response.data.lastInspectionDate
                        this.editedItem.jumps = response.data.jumps
                        this.editedItem.jumpsLeft = response.data.jumpsLeft


                            Object.assign(this.components[this.editedIndex], this.editedItem)


                            if (this.editedItem.rig.length > 0 )
                                { this.$store.dispatch('fetchRigs') }

                                    this.close()
                                                    
                                })
                                    .catch( err => {
                                        console.log( err )
                                })



                  } else {
                    console.log("Canceled by user")
                  }

              }
          }
    }
</script>